import { createFileRoute } from '@tanstack/react-router';

import { PolicyForm } from '../../features/policies';

export const Route = createFileRoute('/_agent/policies/edit/$policyId')({
  component: PolicyForm,
});
